export const initialise = () => {
    const widgets = document.querySelectorAll('.attrax-list-widget');
    widgets.forEach((widget) => {
        removeViewAllFromListWidget(widget);
        transformToH3(widget);
    }
)};

export const removeViewAllFromListWidget = (widget: Element) => {
    const list = widget.querySelector('.attrax-list-widget__list');
    if (!list) return;
    const link = list.querySelector(':scope > a');
    const parent = list.parentElement;
    if (!link || !parent) return;
    parent.appendChild(link)
};

export const transformToH3 = (widget: Element) => {
    const paragraph = widget.querySelector('p[role="heading"][aria-level="2"]');
    if (!paragraph) return;

    const h3Element = document.createElement('h3');
    [...paragraph.attributes].forEach(attr => {
        if (attr.name !== 'role' && attr.name !== 'aria-level') {
            h3Element.setAttribute(attr.name, attr.value);
        }
    });

    h3Element.innerHTML = paragraph.innerHTML;
    paragraph.replaceWith(h3Element);
};